import type {
  CampaignStatus,
  LaunchedCampaignDetail,
  SyncStatus,
  CampaignStatusFilter,
} from '../types/campaigns.types';

export interface LaunchedCampaignApi {
  id: string;
  name: string;
  launched_at: string;
  external_id: string | null;
  created_at: string;
  updated_at: string;
  client_id: string | null;
  client_ext_client_id: string | null;
  client_title: string | null;
  status: CampaignStatus;
  status_updated_at: string | null;
  status_updated_by_email: string | null;
  assigned_to_id: string | null;
  assigned_to_email: string | null;
  assigned_at: string | null;
  monday_sync_status: boolean;
  monday_item_id: string | null;
  slack_notification_status: boolean;
  notification_errors: Record<string, string>;
  payload: Record<string, unknown>;
}

export interface LaunchedCampaignsPaginatedResponse {
  items: LaunchedCampaignApi[];
  total_objects: number;
  total_pages: number;
  page: number;
  page_size: number;
}

export interface ListLaunchedCampaignsParams {
  status?: CampaignStatus;
  page?: number;
  page_size?: number;
}

function mapSyncStatus(
  synced: boolean,
  errors: Record<string, string>,
  key: string,
): SyncStatus {
  if (synced) {
    return 'synced';
  }
  if (errors[key]) {
    return 'failed';
  }
  return 'pending';
}

export function mapLaunchedCampaign(campaign: LaunchedCampaignApi) {
  return mapLaunchedCampaignDetail(campaign);
}

export function mapLaunchedCampaignDetail(campaign: LaunchedCampaignApi): LaunchedCampaignDetail {
  return {
    id: campaign.id,
    name: campaign.name,
    externalId: campaign.external_id,
    clientId: campaign.client_id,
    clientExtClientId: campaign.client_ext_client_id,
    client: campaign.client_title,
    launchedAt: campaign.launched_at,
    createdAt: campaign.created_at,
    updatedAt: campaign.updated_at,
    statusUpdatedAt: campaign.status_updated_at,
    statusUpdatedByEmail: campaign.status_updated_by_email,
    assignedToEmail: campaign.assigned_to_email,
    assignedAt: campaign.assigned_at,
    status: campaign.status,
    mondaySync: mapSyncStatus(
      campaign.monday_sync_status,
      campaign.notification_errors,
      'monday',
    ),
    slackSync: mapSyncStatus(
      campaign.slack_notification_status,
      campaign.notification_errors,
      'slack',
    ),
    mondayItemId: campaign.monday_item_id,
    notificationErrors: campaign.notification_errors,
    payload: campaign.payload ?? {},
  };
}

export function statusFilterToQuery(statusFilter: CampaignStatusFilter): CampaignStatus | undefined {
  if (statusFilter === 'all') {
    return undefined;
  }
  return statusFilter;
}
